import { Button } from "antd";
import SidebarLayout from "components/Layout/Layout";
import { API_URL } from "env";
import { User } from "pages/Dasboard/MainDashBoard/component/UserAccountList";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const UserMainPage = () => {
    const { userID } = useParams();
    const [userData, setUserData] = useState<User | undefined>();
    async function fetchUserData(userId: string) {
        try {
            const response = await fetch(`${API_URL}api/v1/be/user/${userId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (!response.ok) {
                throw new Error('Failed to fetch user data');
            }
            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error('Error fetching user data:', error);
            return undefined;
        }
    }
    useEffect(() => {
        if (userID) {
            fetchUserData(userID).then(data => {
                if (data) {
                    setUserData({
                        id: data.id,
                        firstName: data.first_name,
                        lastName: data.last_name,
                        email: data.email,
                        jobTitle: data.job_title,
                        KYC: data.kyc_verified,
                        phonenumber: data.phone,
                        country: data.country,
                        city: data.city,
                        address: data.address,
                        postalCode: data.postal_code,
                        dateOfBirth: data.date_of_birth,
                        gender: data.gender,
                        avatar_url: data.avatar_url,
                        isActive: data.is_active,
                        status: data.status,
                        name: "",
                        balance: 0,
                        accountType: data.account_type,
                        lastLogin: data.last_login,
                        createAt: data.created_at,
                        updateAt: data.updated_at,
                    });
                }
            });
        }
    }, [userID]);
    return (
        <SidebarLayout
            title={
                (
                    <h4 className="text-2xl font-bold mb-4 text-gray-800 py-4">
                        Users Management Dashboard
                    </h4>
                )
            }
        >
            <main className="p-6">
                <div className="space-y-6">
                    <HeaderSection />
                    <UserSummaryCard user={userData} />
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className="space-y-6">
                            <ContactInfo user={userData} />
                            <AccountStatistics />
                        </div>
                        <div className="space-y-6">
                            <RecentActivity />
                            <RiskAssessment />
                        </div>
                        <div className="space-y-6">
                            <QuickActions />
                        </div>
                    </div>
                </div>
            </main>
        </SidebarLayout>
    );
}
export default UserMainPage;


const HeaderSection = () => (
    <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
            <button
                name="back-button"
                title="Back to previous page"
                onClick={() => window.history.back()}
                className="p-2  hover: hover: rounded-lg transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-arrow-left">
                    <path d="m12 19-7-7 7-7"></path>
                    <path d="M19 12H5"></path>
                </svg>
            </button>
            <div>
                <h2 className="text-2xl font-bold ">Chi tiết người dùng</h2>
                <p className=" mt-1">Thông tin chi tiết và quản lý tài khoản</p>
            </div>
        </div>
        <div className="flex items-center space-x-3">
            <button className="px-4 py-2  hover:bg-blue-700  rounded-lg font-medium transition-colors flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-square-pen mr-2">
                    <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z"></path>
                </svg>
                Chỉnh sửa
            </button>
        </div>
    </div>
);

const UserSummaryCard = ({ user }: { user?: User }) => (
    <div className=" rounded-lg p-6 border border-gray-700">
        <div className="flex items-center space-x-6">
            <div className="w-24 h-24  rounded-full flex items-center justify-center  text-3xl font-bold">
                {user?.avatar_url ? (
                    <img src={user.avatar_url} alt="User Avatar" className="w-full h-full rounded-full object-cover" />
                ) : (
                    <span className="text-gray-500">No Image</span>
                )}
            </div>
            <div className="flex-1">
                <h3 className="text-2xl font-bold ">{user?.firstName + ' ' + user?.lastName}</h3>
                <p className=" text-lg">{user?.jobTitle}</p>
                <p className=" font-mono">ID: {user?.id}</p>
                <div className="flex items-center space-x-4 mt-2">
                    <span className="px-3 py-1 rounded-full text-sm font-medium bg-green-900 text-green-300">Hoạt động</span>
                    {user?.KYC ? (
                        <span className="px-3 py-1 rounded-full text-sm font-medium bg-blue-900 text-blue-300">KYC Đã xác minh</span>
                    ) : (
                        <span className="px-3 py-1 rounded-full text-sm font-medium bg-yellow-900 text-yellow-300">KYC Chưa xác minh</span>
                    )}
                    <span className="font-medium text-green-400">Rủi ro: Thấp</span>
                </div>
            </div>
            <div className="text-right">
                <p className=" text-sm">Số dư hiện tại</p>
                <p className="text-3xl font-bold text-green-400">$25,400</p>
                <p className=" text-sm">
                    <span className="px-2 py-1 rounded text-xs font-medium bg-purple-900 text-purple-300">Premium</span>
                </p>
            </div>
        </div>
    </div>
);

const ContactInfo = ({ user }: { user?: User }) => (
    <div className=" rounded-lg p-6 border border-gray-700">
        <h4 className="text-lg font-semibold  mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-user mr-2 ">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
            </svg>
            Thông tin cá nhân
        </h4>
        <div className="space-y-4">
            <div>
                <label className="block text-sm font-medium  mb-1">Họ và tên</label>
                <p className="">{user?.firstName + ' ' + user?.lastName}</p>
            </div>
            <div>
                <label className="block text-sm font-medium  mb-1">Vị trí</label>
                <p className="">{user?.jobTitle}</p>
            </div>
            <div>
                <label className="block text-sm font-medium  mb-1">Ngày tham gia</label>
                <p className="">{user?.createAt}</p>
            </div>
            <div>
                <label className="block text-sm font-medium  mb-1">Hoạt động cuối</label>
                <p className="">{user?.lastLogin}</p>
            </div>
        </div>
    </div>
);

const AccountStatistics = () => (
    <div className=" rounded-lg p-6 border border-gray-700">
        <h4 className="text-lg font-semibold  mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-up mr-2 text-purple-400">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                <polyline points="16 7 22 7 22 13"></polyline>
            </svg>
            Thống kê giao dịch
        </h4>
        <div className="space-y-4">
            <div className="flex items-center justify-between p-3  rounded-lg">
                <span className="">Tổng giao dịch:</span>
                <span className=" font-bold">156</span>
            </div>
            <div className="flex items-center justify-between p-3  rounded-lg">
                <span className="">Lệnh đang mở:</span>
                <span className=" font-bold">3</span>
            </div>
            <div className="flex items-center justify-between p-3  rounded-lg">
                <span className="">Tổng nạp tiền:</span>
                <span className="text-green-400 font-mono">$50,000</span>
            </div>
            <div className="flex items-center justify-between p-3  rounded-lg">
                <span className="">Tổng rút tiền:</span>
                <span className="text-red-400 font-mono">$24,600</span>
            </div>
            <div className="flex items-center justify-between p-3  rounded-lg">
                <span className="">P&amp;L:</span>
                <span className="font-mono font-bold text-green-400">+$1,250</span>
            </div>
        </div>
    </div>
);

const RecentActivity = () => (
    <div className=" rounded-lg p-6 border border-gray-700">
        <h4 className="text-lg font-semibold  mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-activity mr-2 text-orange-400">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
            </svg>
            Hoạt động gần đây
        </h4>

    </div>
);

const QuickActions = () => (
    <div className=" rounded-lg p-6 border border-gray-700">
        <h4 className="text-lg font-semibold  mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-settings mr-2 text-yellow-400">
                <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18..."></path>
                <circle cx="12" cy="12" r="3"></circle>
            </svg>
            Thao tác nhanh
        </h4>
        <div className="gap-3 w-full flex flex-col">
            <Button
                type="primary"
                size="large"
                className="w-full flex items-center justify-center"
                onClick={() => alert('Chỉnh sửa thông tin người dùng')}
            >
                Chỉnh sửa tài khoản giao dịch
            </Button>
            <Button
                type="primary"
                size="large"
                className="w-full flex items-center justify-center"
                onClick={() => alert('Xem lịch sử giao dịch')}
            >
                Xem lịch sử giao dịch
            </Button>
        </div>

    </div>
);

const RiskAssessment = () => (
    <div className=" rounded-lg p-6 border border-gray-700">
        <h4 className="text-lg font-semibold  mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-alert-triangle mr-2 text-red-400">
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                <path d="M12 9v4"></path>
                <path d="M12 17h.01"></path>
            </svg>
            Đánh giá rủi ro
        </h4>

    </div>
);